var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoubleCross = function SvgDoubleCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.707.293a1 1 0 0 0 0 1.414L5 6 1.1 9.9a1 1 0 1 0 1.415 1.414l3.9-3.9L9.898 10.9a1 1 0 0 0 1.415-1.415L7.828 6l3.879-3.879A1 1 0 0 0 10.293.707L6.414 4.586 2.121.293a1 1 0 0 0-1.414 0ZM10.999 6a1 1 0 0 1 1.414-1.414l3.88-3.879a1 1 0 1 1 1.414 1.414l-3.879 3.88 3.486 3.484a1 1 0 0 1-1.415 1.415l-3.485-3.486A1 1 0 0 1 11 6Z",
    fill: "currentColor"
  })));
};
export default SvgDoubleCross;